<template>
  <section class="max-w-2xl mx-auto py-12">
    <h1 class="text-3xl font-bold mb-6">Récapitulatif de votre abonnement</h1>
    <div class="bg-white rounded-lg shadow p-6 mb-6 text-left">
      <h2 class="text-xl font-semibold mb-2 text-center">{{ abonnement.nom }}</h2>
      <p class="mb-2">
        <span class="font-bold">Prix :</span>
        {{ abonnement.prixTTC }} € TTC ({{ abonnement.prixHT }} € HT)
      </p>
      <p class="mb-2">
        <span class="font-bold">Durée :</span>
        {{ abonnement.duree === 'year' ? 'Annuel' : 'Mensuel' }}
      </p>
      <p class="mb-2">
        <span class="font-bold">Renouvellement :</span>
        {{ abonnement.dateRenouvellement }}
      </p>
      <ul class="list-disc ml-6 mt-4 text-gray-700">
        <li v-for="f in abonnement.features" :key="f">{{ f }}</li>
      </ul>
    </div>
    <form class="bg-gray-50 rounded-lg shadow p-6 mb-6">
      <h3 class="font-semibold mb-4">Coordonnées de facturation</h3>
      <div class="mb-3 text-left">
        <label class="block mb-1 font-semibold">Nom</label>
        <input v-model="client.nom" class="w-full border rounded px-3 py-2" required />
      </div>
      <div class="mb-3 text-left">
        <label class="block mb-1 font-semibold">Email</label>
        <input v-model="client.email" type="email" class="w-full border rounded px-3 py-2" required />
      </div>
      <div class="mb-3 text-left">
        <label class="block mb-1 font-semibold">Adresse</label>
        <input v-model="client.adresse" class="w-full border rounded px-3 py-2" required />
      </div>
    </form>
    <div class="flex items-center mb-6">
      <input type="checkbox" v-model="acceptCGV" class="mr-2" />
      <label class="text-sm">J'accepte les <a class="underline text-primary cursor-pointer" @click="cgvPopopVisible=true">CGV</a> et la <a class="underline text-primary cursor-pointer" @click="privacyPolicyPopupVisible=true">Politique de confidentialité</a></label>
    </div>
    <button
      :disabled="!acceptCGV"
      class="!bg-primary hover:!bg-primary-dark text-white font-bold !py-5 flex justify-center items-center px-8 cursor-pointer rounded shadow-lg transition w-full disabled:opacity-50"
      @click="goToPaiement"
    >
      Confirmer et payer ({{ total }} € TTC)
    </button>
  </section>

  <Popup :visible="cgvPopopVisible" @close="cgvPopopVisible = false" :title="'CGV'" :noButtons="true">
    <template #header>
      <h2 class="text-xl font-bold">Conditions Générales de Vente</h2>
    </template>
        <!-- Section 1 - Identité -->
        <section class="mb-10">
            <h2 class="text-2xl font-semibold text-blue-700 mb-4 flex items-center">
                <span class="bg-blue-100 p-2 rounded-full mr-3">
                    <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5 text-blue-600" viewBox="0 0 20 20" fill="currentColor">
                        <path fill-rule="evenodd" d="M10 9a3 3 0 100-6 3 3 0 000 6zm-7 9a7 7 0 1114 0H3z" clip-rule="evenodd" />
                    </svg>
                </span>
                1. Identité du vendeur
            </h2>
            <div class="bg-blue-50 p-5 rounded-lg border border-blue-100">
                <p><strong>NAILIT-SOLUTIONS</strong></p>
                <p>SAS au capital de 10 000 €</p>
                <p>RCS Paris 123 456 789</p>
                <p>N° TVA : FR00123456789</p>
                <p>Adresse : 25 Rue du Progrès, 75015 Paris</p>
                <p>Email : <a href="mailto:contact@nailit-solutions.com" class="text-blue-600 hover:underline">contact@nailit-solutions.com</a></p>
            </div>
        </section>

        <!-- Section 2 - Services -->
        <section class="mb-10">
            <h2 class="text-2xl font-semibold text-blue-700 mb-4 flex items-center">
                <span class="bg-blue-100 p-2 rounded-full mr-3">
                    <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5 text-blue-600" viewBox="0 0 20 20" fill="currentColor">
                        <path d="M10.394 2.08a1 1 0 00-.788 0l-7 3a1 1 0 000 1.84L5.25 8.051a.999.999 0 01.356-.257l4-1.714a1 1 0 11.788 1.838L7.667 9.088l1.94.831a1 1 0 00.787 0l7-3a1 1 0 000-1.838l-7-3zM3.31 9.397L5 10.12v4.102a8.969 8.969 0 00-1.05-.174 1 1 0 01-.89-.89 11.115 11.115 0 01.25-3.762zM9.3 16.573A9.026 9.026 0 007 14.935v-3.957l1.818.78a3 3 0 002.364 0l5.508-2.361a11.026 11.026 0 01.25 3.762 1 1 0 01-.89.89 8.968 8.968 0 00-5.35 2.524 1 1 0 01-1.4 0zM6 18a1 1 0 001-1v-2.065a8.935 8.935 0 00-2-.712V17a1 1 0 001 1z" />
                    </svg>
                </span>
                2. Services proposés
            </h2>
            <div class="space-y-4">
                <p>Nailit propose un logiciel SaaS de gestion de projet comprenant :</p>
                <ul class="list-disc pl-6 space-y-2">
                    <li>Un planning interactif horizontal</li>
                    <li>Un système de gestion des tâches</li>
                    <li>Un suivi de trésorerie intégré</li>
                    <li>Une boîte à idées collaborative</li>
                    <li>Des outils de gestion des ressources</li>
                </ul>
                <p class="text-sm text-gray-600">Les fonctionnalités exactes varient selon les formules d'abonnement souscrites.</p>
            </div>
        </section>

        <!-- Section 3 - Prix -->
        <section class="mb-10">
            <h2 class="text-2xl font-semibold text-blue-700 mb-4 flex items-center">
                <span class="bg-blue-100 p-2 rounded-full mr-3">
                    <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5 text-blue-600" viewBox="0 0 20 20" fill="currentColor">
                        <path d="M8.433 7.418c.155-.103.346-.196.567-.267v1.698a2.305 2.305 0 01-.567-.267C8.07 8.34 8 8.114 8 8c0-.114.07-.34.433-.582zM11 12.849v-1.698c.22.071.412.164.567.267.364.243.433.468.433.582 0 .114-.07.34-.433.582a2.305 2.305 0 01-.567.267z" />
                        <path fill-rule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm1-13a1 1 0 10-2 0v.092a4.535 4.535 0 00-1.676.662C6.602 6.234 6 7.009 6 8c0 .99.602 1.765 1.324 2.246.48.32 1.054.545 1.676.662v1.941c-.391-.127-.68-.317-.843-.504a1 1 0 10-1.51 1.31c.562.649 1.413 1.076 2.353 1.253V15a1 1 0 102 0v-.092a4.535 4.535 0 001.676-.662C13.398 13.766 14 12.991 14 12c0-.99-.602-1.765-1.324-2.246A4.535 4.535 0 0011 9.092V7.151c.391.127.68.317.843.504a1 1 0 101.511-1.31c-.563-.649-1.413-1.076-2.354-1.253V5z" clip-rule="evenodd" />
                    </svg>
                </span>
                3. Prix et paiement
            </h2>
            <div class="bg-white p-5 rounded-lg border border-gray-200 shadow-sm">
                <h3 class="font-medium text-gray-900 mb-3">Tarification :</h3>
                <ul class="space-y-3">
                    <li class="flex justify-between">
                        <span>Formule Basique :</span>
                        <span class="font-medium">9€ TTC/mois</span>
                    </li>
                    <li class="flex justify-between">
                        <span>Formule Pro :</span>
                        <span class="font-medium">15€ TTC/mois</span>
                    </li>
                    <li class="flex justify-between">
                        <span>Formule Entreprise :</span>
                        <span class="font-medium">29€ TTC/mois</span>
                    </li>
                </ul>

                <div class="mt-6">
                    <h3 class="font-medium text-gray-900 mb-3">Modalités de paiement :</h3>
                    <p>Paiement par carte bancaire (Stripe) ou virement SEPA. Les abonnements sont facturés :</p>
                    <ul class="list-disc pl-6 mt-2 space-y-1">
                        <li>À la souscription</li>
                        <li>Puis automatiquement à chaque renouvellement</li>
                    </ul>
                </div>

                <div class="mt-6 p-4 bg-yellow-50 border-l-4 border-yellow-400">
                    <p class="text-yellow-700"><strong>Remarque :</strong> Aucun frais caché. Résiliation possible à tout moment.</p>
                </div>
            </div>
        </section>
  </Popup>

  <Popup :visible="privacyPolicyPopupVisible" @close="privacyPolicyPopupVisible = false" :title="'Politique de confidentialité'" :noButtons="true">
    <template #header>
      <h2 class="text-xl font-bold">Politique de confidentialités</h2>
    </template>
    <div class="p-4">
      <p>Voici les pdc...</p>
    </div>
  </Popup>
</template>

<script>
import Popup from '@/components/Popups/Popup.vue';

export default {
  name: 'PaymentSummary',
  components: {
    Popup
  },
  data() {
    return {
      abonnement: {
        nom: 'Pro',
        prixTTC: 144,
        prixHT: 120,
        duree: 'year',
        dateRenouvellement: '13 mai 2026',
        features: [
          "Collaboration en équipe",
          "Rappels automatiques",
          "Support prioritaire"
        ],
        priceId: 'price_bfferjfrej',
      },
      addons: {
        stockage: false
      },
      client: {
        nom: 'Dupont',
        email: 'dupont@email.com',
        adresse: '1 rue de la Paix, 75000 Paris'
      },
      acceptCGV: false,
      cgvPopopVisible: false,
      privacyPolicyPopupVisible: false
    };
  },
  mounted() {
    if (this.$route.query.nom) {
      this.abonnement.nom = this.$route.query.nom;
      this.abonnement.duree = this.$route.query.duree;
      this.abonnement.features = JSON.parse(this.$route.query.features);
      this.abonnement.priceMonth = Number(this.$route.query.priceMonth);
      this.abonnement.priceId = this.$route.query.priceId;

      // Calcul des prix
      if (this.abonnement.duree === 'year') {
        this.abonnement.prixTTC = Math.round(this.abonnement.priceMonth * 0.8 * 12);
        this.abonnement.prixHT = Math.round(this.abonnement.priceMonth * 0.8 * 12 * 0.8333);
      } else {
        this.abonnement.prixTTC = this.abonnement.priceMonth;
        this.abonnement.prixHT = Math.round(this.abonnement.priceMonth * 0.8333);
      }
      
      // Calcul automatique de la date de renouvellement
      const now = new Date();
      if (this.abonnement.duree === 'year') {
        now.setFullYear(now.getFullYear() + 1);
      } else {
        now.setMonth(now.getMonth() + 1);
      }
      // Format : 13 mai 2026
      const mois = [
        "janvier", "février", "mars", "avril", "mai", "juin",
        "juillet", "août", "septembre", "octobre", "novembre", "décembre"
      ];
      this.abonnement.dateRenouvellement = `${now.getDate()} ${mois[now.getMonth()]} ${now.getFullYear()}`;
    }
  },
  computed: {
    total() {
      let total = this.abonnement.prixTTC;
      if (this.addons.stockage) total += this.abonnement.duree === 'year' ? 24 : 2;
      return total;
    }
  },
  methods: {
    goToPaiement() {
      if (this.acceptCGV) {
        // Passe les infos en query (ou mieux : via un store)
        this.$router.push({
          path: '/payment',
          query: {
            nom: this.abonnement.nom,
            duree: this.abonnement.duree,
            features: JSON.stringify(this.abonnement.features),
            priceMonth: this.abonnement.priceMonth,
            prixTTC: this.abonnement.prixTTC,
            prixHT: this.abonnement.prixHT,
            clientNom: this.client.nom,
            clientEmail: this.client.email,
            clientAdresse: this.client.adresse,
            priceId: this.abonnement.priceId,          
          }
        });
      }
    }
  }
};
</script>